var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightBottom"},[_c('div',{staticClass:"trendClass"},[_c('div',{staticClass:"filterBox"}),_c('p',{staticClass:"title"},[_vm._v("活动统计")]),_c('div',{staticStyle:{"width":"420px","height":"280px"},attrs:{"id":"rightline"}})])])
}]

export { render, staticRenderFns }